__turbopack_context__.v({
  "deleteButton": "IssuePageInformationSection-module__SXG8mG__deleteButton",
  "disabledUploadContainer": "IssuePageInformationSection-module__SXG8mG__disabledUploadContainer",
  "divider": "IssuePageInformationSection-module__SXG8mG__divider",
  "enabledUploadContainer": "IssuePageInformationSection-module__SXG8mG__enabledUploadContainer",
  "imageSlideContainer": "IssuePageInformationSection-module__SXG8mG__imageSlideContainer",
  "infoSection": "IssuePageInformationSection-module__SXG8mG__infoSection",
  "uploadContainer": "IssuePageInformationSection-module__SXG8mG__uploadContainer",
});
